import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-question-input',
  standalone: false,
  templateUrl: './question-input.component.html',
  styleUrl: './question-input.component.scss'
})
export class QuestionInputComponent {

  @Input() checked: boolean = false;
  @Input() label: string = '';
  @Input() id: number | null = null;
  @Output() checkedChange = new EventEmitter<any>();

  constructor(){}

  ngAfterViewInit(): void {
  }

  onChange(event: any){
    this.checkedChange.emit({
      checked: this.checked,
      id: this.id
    });
  }

}
